PageApp.Controllers.ApplicationRouter = function (config) {
  function checkForError (response) {
    var failed = false
    if (response && response.failed) {
      if (response.models && response.models.ErrorModel) {
        if (response.models.ErrorModel.code === 'reload') {
          window.location.reload()
        }
        myApp.vent.trigger('ui:notification', { text: response.models.ErrorModel.message, level: 'warning' })
      } else {
        myApp.vent.trigger('ui:notification', { text: 'error - please reload the page', level: 'warning' })
      }
      failed = true
    } else if (response.models && response.models.ErrorModel) {
      myApp.vent.trigger('ui:notification', { text: response.models.ErrorModel.message, level: 'warning' })
      failed = true
    }
    return failed
  }

  function redirectToHome () {
    myApp.router.navigate('#!/home', { trigger: true })
  }

  function redirectToUserSettings () {
    myApp.router.navigate('#!/mySettings', { trigger: true })
  }

  function hasMissingUserDetails () {
    return (myApp.ent.user.isLoggedIn() && myApp.ent.config.getOAuthLoginEndpoint() && myApp.ent.user.get('statusId') === 7)
  }

  function hasOAuthEnabled () {
    return (myApp.ent.config.getOAuthLoginEndpoint())
  }

  function setSecurePath (model, pageKey) {
    var securePath = '#!/notFound'
    if (model && model.secureQuery) {
      securePath = '#!/' + model.secureQuery
      if (model.secureQuery.indexOf('auctionDetails') > -1) {
        securePath += '/' + model.auction.id
      } else if (model.secureQuery.indexOf('itemDetails') > -1) {
        securePath += '/' + model.id
      }
    }
    myApp.ent.config.set({ 'page': pageKey, 'secureQuery': securePath })
  }

  function getParameterByName (name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    var results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  function setPage (isTitleOverridable, isMetaDescriptionOverridable, metaModel) {
    if (isTitleOverridable) {
      document.title = (metaModel && metaModel.metaTitle) ? metaModel.metaTitle : myApp.ent.metaModel.get('metaTitle')
    }
    if (isMetaDescriptionOverridable) {
      var metaDescElement = document.querySelector('meta[name="description"]')
      if (metaDescElement) {
        metaDescElement.setAttribute('content', (metaModel && metaModel.metaDescription) ? metaModel.metaDescription : myApp.ent.metaModel.get('metaDescription'))
      }
    }
  }

  var setPageMeta
  function initRoutes (obj) {
    var context = '!/'
    var appRoutes = {}
    appRoutes[context] = 'homeRequest'
    appRoutes[''] = 'homeRequest'
    appRoutes['home'] = 'homeRequest'
    appRoutes[context + 'home'] = 'homeRequest'
    appRoutes[context + 'login'] = 'loginRequest'
    appRoutes[context + 'logout'] = 'logoutRequest'
    appRoutes[context + 'changePassword'] = 'changePasswordRequest'
    appRoutes[context + 'forgottenPassword'] = 'forgottenPasswordRequest'
    appRoutes[context + 'createAccount'] = 'createAccountRequest'
    appRoutes[context + 'mySettings'] = 'mySettingsRequest'
    appRoutes[context + 'confirmEmail'] = 'confirmEmailRequest'
    appRoutes[context + 'calendar'] = 'calendarRequest'
    // appRoutes[context + "myBids/:filterId"] = "myBids"; NYI
    appRoutes[context + 'marketplace'] = 'marketplaceRequest'
    appRoutes[context + 'marketplaceSecure'] = 'marketplaceRequest'
    appRoutes[context + 'marketplace?:query'] = 'marketplaceRequest'
    appRoutes[context + 'marketplaceSecure?:query'] = 'marketplaceRequest'
    appRoutes[context + 'search'] = 'searchRequest'
    appRoutes[context + 'searchSecure'] = 'searchRequest'
    appRoutes[context + 'webcast2/:auctionId'] = 'webcastRequest'
    appRoutes[context + 'myBids(/:filterId)'] = 'myBidsRequest'
    appRoutes[context + 'auctionDetails/:auctionId'] = 'auctionDetailsRequest'
    appRoutes[context + 'auctionDetails/:auctionId?:query'] = 'auctionDetailsRequest'
    appRoutes[context + 'auctionDetailsSecure/:auctionId'] = 'auctionDetailsSecureRequest'
    appRoutes[context + 'auctionDetailsSecure/:auctionId?:query'] = 'auctionDetailsSecureRequest'
    appRoutes[context + 'itemDetails/:auctionId/:itemId'] = 'itemDetailsRequest'
    appRoutes[context + 'itemDetailsSecure/:auctionId/:itemId'] = 'itemDetailsSecureRequest'
    appRoutes[context + 'prevNextItemDetails/:itemId/:prevnext'] = 'prevNextItemDetailsRequest'
    appRoutes[context + 'registerForAuction/:prevnext'] = 'registerForAuctionRequest'
    // ensure that if bidJS modules are enabled, we don't 404 when showing those modules
    window.bidjs && Object.keys(window.bidjs.modules).forEach(function (key) {
      if (window.bidjs.modules[key]) appRoutes[context + key + '*(/)(:level1)(/)(:level2)(/)(:level3)(/)'] = 'nullRequest'
    })

    appRoutes['*notFound'] = 'notFoundRequest'
    obj.router = new Marionette.AppRouter({
      controller: obj,
      appRoutes: appRoutes
    })
    obj.router.onRoute = function (name, path, args) {
      myApp.utils.misc.resetScrollPosition()
      if (name.indexOf('registerForAuction') === -1 && name.indexOf('login') === -1 && name.indexOf('logout') === -1) {
        myApp.ent.config.set('referer', '#' + Backbone.history.fragment)
      }
      myApp.vent.trigger('lightbox:close')
      // prettyPhoto doesn't provide a method for us to see if it's open, so we need to try / catch it, as it throws an error if you try to close it without it being open
      if ($.prettyPhoto && $.prettyPhoto.close) try { $.prettyPhoto.close() } catch (e) {}
    }
  }

  return {
    initialize: function () {
      initRoutes(this)
      setPageMeta = setPage.bind(this,
        (
          myApp.ent.config &&
          myApp.ent.config.attributes.options &&
          myApp.ent.config.attributes.options.allowTitleChange
        ), (
          myApp.ent.config &&
          myApp.ent.config.attributes.options &&
          myApp.ent.config.attributes.options.allowMetaDescriptionChange
        )
      )
    },
    onRoute: function () {
      $('#myModal').hide()
    },
    doRoute: function (event, router) {
      if (!event || !event.href) {
        // only allow calls to this in bidjs from the search filter code
        return
      }
      myApp.router.navigate(event.href, { trigger: true })
    },

    nullRequest: function () {
      myApp.mainRegion.show(new PageApp.Views.NullView())
      setPageMeta()
    },

    notFoundRequest: function (path) {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.mainRegion.show(new PageApp.Views.ErrorNotFoundView({ model: myApp.ent.fourOFour }))
      setPageMeta()
    },

    createAccountRequest: function () {
      if (myApp.ent.user.isLoggedIn() || hasOAuthEnabled()) {
        return redirectToHome()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('createAccount'), _.bind(function (models) {
        myApp.ent.config.set('page', 'create account')
        myApp.vent.trigger('account:create:display', models)
        setPageMeta((models && models.metaModel))
        myApp.myModalRegion.empty()
      }, this))
    },
    mySettingsRequest: function () {
      if (myApp.ent.user.isLoggedIn()) {
        myApp.myModalRegion.show(new PageApp.Views.WaitingView())
        myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('mySettings'), _.bind(function (models) {
          myApp.ent.config.set('page', 'my settings')
          myApp.vent.trigger('account:mysettings:display', models)
          setPageMeta((models && models.metaModel))
          myApp.myModalRegion.empty()
        }, this))
      } else {
        myApp.mainRegion.empty()
        myApp.router.navigate('#!/login', { trigger: true })
      }
    },
    confirmEmailRequest: function () {
      if (hasOAuthEnabled()) {
        return redirectToHome()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('confirmEmail') + '?id=' + getParameterByName('id') + '&key=' + getParameterByName('key'), _.bind(function (models) {
        myApp.ent.config.set('page', 'create account')
        myApp.vent.trigger('account:activate:success', models)
        setPageMeta((models && models.MetaModel))
        myApp.myModalRegion.empty()
      }, this))
    },
    forgottenPasswordRequest: function () {
      if (myApp.ent.user.isLoggedIn() || hasOAuthEnabled()) {
        return redirectToHome()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('forgottenPassword'), _.bind(function (response) {
        setPageMeta((response && response.models && response.models.MetaModel))
        myApp.vent.trigger('account:forgotten:display', response)
        myApp.myModalRegion.empty()
      }, this))
    },
    changePasswordRequest: function () {
      if (myApp.ent.user.isLoggedIn() || hasOAuthEnabled()) {
        return redirectToHome()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('changePassword') + '?id=' + getParameterByName('id') + '&key=' + getParameterByName('key'), _.bind(function (response) {
        setPageMeta({
          metaTitle: 'Change Password'
        })
        myApp.vent.trigger('account:change:password:display', response)
        myApp.myModalRegion.empty()
      }, this))
    },
    logoutRequest: function (e) {
      myApp.vent.trigger('authentication:remove', false)
    },
    loginRequest: function (e) {
      if (myApp.ent.user.isLoggedIn()) {
        return redirectToHome()
      }
      if (myApp.utils.oAuth.isUsingOAuth()) {
        var redirectUrl = encodeURIComponent(window.location.origin + window.location.pathname + myApp.ent.config.get('referer'))
        var loginEndpoint = myApp.ent.config.getOAuthLoginEndpoint().replace('<<REDIRECT>>', redirectUrl)
        window.location.replace(loginEndpoint)
      } else {
        myApp.vent.trigger('login:display')
      }
    },
    homeRequest: function () {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('home'), _.bind(function (response) {
        if (checkForError(response)) return
        myApp.ent.config.set('page', 'home')
        response.models.options = { ignoreEvents: true }
        myApp.controllers.homeCalRouter = new PageApp.Controllers.HomeCalRouter()
        myApp.controllers.homeCalRouter.initialize()
        myApp.vent.trigger('homecal:display', response.models)
        setPageMeta((response && response.models && response.models.MetaModel))
        myApp.myModalRegion.empty()
      }, this))
    },
    calendarRequest: function () {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('auctionCalendar'), _.bind(function (response) {
        if (checkForError(response)) return
        myApp.ent.config.set('page', 'calendar')
        response.models.options = { ignoreEvents: true }
        myApp.controllers.homeCalRouter = new PageApp.Controllers.HomeCalRouter()
        myApp.controllers.homeCalRouter.initialize()
        myApp.vent.trigger('homecal:display', response.models)
        setPageMeta((response && response.models && response.models.MetaModel))
        myApp.myModalRegion.empty()
      }, this))
    },
    auctionCalendar: function () {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('auctionCalendar'), _.bind(function (response) {
        if (checkForError(response)) return
        setPageMeta((response && response.models && response.models.MetaModel))
        myApp.ent.config.set('page', 'calendar')
        myApp.vent.trigger('homecal:display', response.models)
        myApp.myModalRegion.empty()
      }, this))
    },
    content: function (page) {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('content/plain') + '/' + page, _.bind(function (response) {
        if (checkForError(response)) return
        setPageMeta((response && response.models && response.models.MetaModel))
        myApp.ent.config.set('page', 'content')
        myApp.vent.trigger('content:display', response)
        myApp.myModalRegion.empty()
      }, this))
    },
    auctionDetailsSecureRequest: function (auctionId, query) {
      if (myApp.ent.user.isLoggedIn()) {
        if (hasMissingUserDetails()) {
          return redirectToUserSettings()
        }
        return this.auctionDetailsRequest(auctionId, query)
      } else {
        myApp.vent.trigger('login:display', { 'originator': 'auctionland' })
      }
    },
    auctionDetailsRequest: function (auctionId, query) {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      // note from Ralph: I'm not sure how this is working, as biddingRegion is not defined
      if (typeof biddingRegion !== 'undefined' && biddingRegion) { // eslint-disable-line no-undef
        new PageApp.Views.PaginationWaitingView({ el: biddingRegion }).render() // eslint-disable-line no-undef
      } else {
        myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      }
      var url = myApp.utils.ajax.getApiEndpoint('auctionDetails') + '/' + auctionId + '?' + query
      myApp.utils.ajax.get(null, url, _.bind(function (response) {
        if (checkForError(response)) {
          myApp.mainRegion.show(new PageApp.Views.ErrorNotFoundView({ model: myApp.ent.fourOFour }))
          myApp.myModalRegion.empty()
          return
        }
        if (response.models.LandingModel.auction.redirectToWebcast) {
          myApp.router.navigate('#!/webcast2/' + auctionId, { trigger: true, replace: true })
          return
        }
        setPageMeta((response && response.models && response.models.MetaModel))
        myApp.ent.config.set({ 'page': 'auctionland', 'secureQuery': '#!/' + response.models.LandingModel.secureQuery })
        if (checkForError(response)) return
        setSecurePath(response.models.LandingModel, 'auctionland')
        var config = { landingModel: response.models.LandingModel }
        myApp.vent.trigger('landing:display', config)
        myApp.myModalRegion.empty()
      }, this))
    },
    webcastRequest: function (auctionId) {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      var url = myApp.utils.ajax.getApiEndpoint('webcast2') + '/' + auctionId
      myApp.utils.ajax.get(null, url, _.bind(function (models) {
        if (checkForError(models)) return
        if (models.preBidding) {
          myApp.router.navigate('#!/auctionDetails/' + auctionId, { trigger: true, replace: true })
          return
        }
        myApp.controllers.webcastRouter.initialize()
        myApp.vent.trigger('webcast:display', models)
        setPageMeta(models && {
          metaTitle: models.pageTitle || null,
          metaDescription: models.pageDescription || null
        })
        myApp.myModalRegion.empty()
      }, this))
    },
    searchRequest: function (query) {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('search') + '?' + query, _.bind(function (response) {
        if (checkForError(response)) return
        setPageMeta((response && response.models && response.models.MetaModel))
        setSecurePath(response.models.LandingModel, 'searchland')
        myApp.vent.trigger('landing:display', { landingModel: response.models.LandingModel })
        myApp.myModalRegion.empty()
      }, this))
    },
    marketplaceRequest: function (query) {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('marketplace') + '?' + query, _.bind(function (response) {
        if (checkForError(response)) return
        setPageMeta((response && response.models && response.models.MetaModel))
        setSecurePath(response.models.LandingModel, 'marketland')
        myApp.vent.trigger('landing:display', { landingModel: response.models.LandingModel })
        myApp.myModalRegion.empty()
      }, this))
    },
    itemDetailsSecureRequest: function (auctionId, itemId) {
      if (myApp.ent.user.isLoggedIn()) {
        if (hasMissingUserDetails()) {
          return redirectToUserSettings()
        }
        return this.itemDetailsRequest(itemId)
      } else {
        myApp.vent.trigger('login:display')
      }
    },
    itemDetailsRequest: function (auctionId, itemId) {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('itemDetails') + '/' + itemId, _.bind(function (response) {
        if (checkForError(response)) return
        setPageMeta((response && response.models && response.models.MetaModel))
        setSecurePath(response.models.SingleItemModel, 'itemland')
        myApp.vent.trigger('itemland:display', response.models.SingleItemModel)
        myApp.myModalRegion.empty()
      }, this))
    },
    prevNextItemDetailsRequest: function (itemId, prevnext) {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('prevNextItemDetails') + '/' + itemId + '/' + prevnext, _.bind(function (response) {
        if (checkForError(response)) return
        setPageMeta((response && response.models && response.models.MetaModel))
        setSecurePath(response.models.SingleItemModel, 'itemland')
        myApp.ent.config.set({ 'page': 'itemland', 'secureQuery': '#!/' + response.models.SingleItemModel.secureQuery })
        myApp.vent.trigger('itemland:display', response.models.SingleItemModel)
        myApp.myModalRegion.empty()
      }, this))
    },
    myBidsRequest: function (filterId, query) {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      if (typeof biddingRegion !== 'undefined' && biddingRegion) { // eslint-disable-line no-undef
        new PageApp.Views.PaginationWaitingView({ el: biddingRegion }).render() // eslint-disable-line no-undef
      } else {
        myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      }
      if (myApp.ent.user.isLoggedIn()) {
        var url = myApp.utils.ajax.getApiEndpoint('myBids') + '/'
        if (filterId) url += filterId
        if (query) {
          url = url + '?' + query
        }
        myApp.utils.ajax.get(null, url, _.bind(function (response) {
          if (checkForError(response)) return
          setPageMeta((response && response.models && response.models.MetaModel))
          myApp.ent.config.set({ 'page': 'myBidsLand', 'secureQuery': '#!/' + response.models.MyBidsModel.secureQuery })
          myApp.vent.trigger('mybids:display', response.models.MyBidsModel)
          myApp.myModalRegion.empty()
        }, this))
      } else {
        myApp.mainRegion.empty()
        myApp.router.navigate('#!/login', { trigger: true })
      }
    },
    registerForAuctionRequest: function (auctionId) {
      if (hasMissingUserDetails()) {
        return redirectToUserSettings()
      }
      myApp.myModalRegion.show(new PageApp.Views.WaitingView())
      if (!myApp.ent.user.isLoggedIn()) {
        myApp.router.navigate('#!/login', { trigger: true })
      } else {
        var myReferer = encodeURIComponent(myApp.ent.config.get('referer'))
        myApp.utils.ajax.get(null, myApp.utils.ajax.getApiEndpoint('registerForAuction') + '/' + auctionId + '?referer=' + myReferer, _.bind(function (response) {
          myApp.vent.trigger('register:display', response)
          setPageMeta((response && response.metaModel))
          myApp.myModalRegion.empty()
        }, this))
      }
    }

  }
}
